import { useState, useEffect, useRef } from 'react';

/* ──────────────  iOS DEMO  ────────────── */
const IOS_APPS = [
  { n: 'Hydrate', c: '#3b82f6' },
  { n: 'TapLedger', c: '#0ea5e9' },
  { n: 'PackPal', c: '#22d3ee' },
  { n: 'Prismatica', c: '#a78bfa' },
  { n: 'Drift', c: '#8b5cf6' },
  { n: 'Lore', c: '#ec4899' },
  { n: 'Synapse', c: '#06b6d4' },
  { n: 'Inflect', c: '#a855f7' },
  { n: 'Resonance', c: '#9333ea' },
  { n: 'Stillway', c: '#ef4444' },
];

const IOSDemo = () => {
  const [order, setOrder] = useState(IOS_APPS.map((_, i) => i));
  useEffect(() => {
    const t = setInterval(() => {
      setOrder((prev) => {
        const next = [...prev];
        const a = Math.floor(Math.random() * next.length);
        let b = Math.floor(Math.random() * next.length);
        if (a === b) b = (b + 1) % next.length;
        [next[a], next[b]] = [next[b], next[a]];
        return next;
      });
    }, 1600);
    return () => clearInterval(t);
  }, []);
  return (
    <div className="demo-ios">
      <div className="ios-bezel">
        <div className="ios-status">
          <span>9:41</span>
          <span className="ios-icons">
            <svg width="14" height="10" viewBox="0 0 14 10"><rect x="0" y="6" width="2" height="4" fill="#fff" /><rect x="3" y="4" width="2" height="6" fill="#fff" /><rect x="6" y="2" width="2" height="8" fill="#fff" /><rect x="9" y="0" width="2" height="10" fill="#fff" /></svg>
            <svg width="14" height="10" viewBox="0 0 14 10"><rect x="0" y="2" width="12" height="6" rx="1.4" fill="none" stroke="#fff" strokeWidth="0.7" /><rect x="1" y="3" width="9" height="4" fill="#fff" /><rect x="13" y="4" width="1" height="2" fill="#fff" /></svg>
          </span>
        </div>
        <div className="ios-grid">
          {order.map((idx) => {
            const a = IOS_APPS[idx];
            return (
              <div key={a.n} className="ios-app" style={{ background: a.c }}>
                <span className="ios-app-letter">{a.n[0]}</span>
                <span className="ios-app-name">{a.n}</span>
              </div>
            );
          })}
        </div>
        <div className="ios-dock">
          <div className="ios-dock-app" style={{ background: '#f5f5f4', color: '#000' }}>A</div>
          <div className="ios-dock-app" style={{ background: '#10b981' }}>M</div>
          <div className="ios-dock-app" style={{ background: '#f59e0b' }}>S</div>
          <div className="ios-dock-app" style={{ background: '#3b82f6' }}>W</div>
        </div>
      </div>
    </div>
  );
};

/* ──────────────  TRADING DEMO  ────────────── */
const TradingDemo = () => {
  const [candles, setCandles] = useState(() => {
    const c = [];
    let last = 67200;
    for (let i = 0; i < 36; i += 1) {
      const open = last;
      const close = last + (Math.random() - 0.45) * 240;
      const high = Math.max(open, close) + Math.random() * 90;
      const low = Math.min(open, close) - Math.random() * 90;
      c.push({ open, close, high, low });
      last = close;
    }
    return c;
  });
  useEffect(() => {
    const t = setInterval(() => {
      setCandles((prev) => {
        const last = prev[prev.length - 1].close;
        const open = last;
        const close = last + (Math.random() - 0.45) * 260;
        const high = Math.max(open, close) + Math.random() * 110;
        const low = Math.min(open, close) - Math.random() * 110;
        return [...prev.slice(1), { open, close, high, low }];
      });
    }, 700);
    return () => clearInterval(t);
  }, []);

  const max = Math.max(...candles.map((c) => c.high));
  const min = Math.min(...candles.map((c) => c.low));
  const range = max - min || 1;
  const lastClose = candles[candles.length - 1].close;
  const prevClose = candles[candles.length - 2].close;
  const delta = lastClose - prevClose;
  const deltaPct = (delta / prevClose) * 100;

  return (
    <div className="demo-trade">
      <div className="trade-bar">
        <div>
          <div className="trade-pair">BTC/USDT</div>
          <div className="trade-price">${lastClose.toFixed(2)}</div>
        </div>
        <div className={`trade-delta ${delta >= 0 ? 'up' : 'down'}`}>
          {delta >= 0 ? '▲' : '▼'} {Math.abs(deltaPct).toFixed(2)}%
        </div>
      </div>
      <svg className="trade-chart" viewBox="0 0 360 140" preserveAspectRatio="none">
        {candles.map((c, i) => {
          const x = (i / candles.length) * 360 + 3;
          const w = 360 / candles.length - 1;
          const y1 = 140 - ((c.high - min) / range) * 130;
          const y2 = 140 - ((c.low - min) / range) * 130;
          const yo = 140 - ((c.open - min) / range) * 130;
          const yc = 140 - ((c.close - min) / range) * 130;
          const up = c.close >= c.open;
          const color = up ? '#10b981' : '#ef4444';
          return (
            <g key={i}>
              <line x1={x + w / 2} x2={x + w / 2} y1={y1} y2={y2} stroke={color} strokeWidth="0.6" />
              <rect x={x} y={Math.min(yo, yc)} width={w} height={Math.max(1, Math.abs(yc - yo))} fill={color} />
            </g>
          );
        })}
      </svg>
      <div className="trade-foot">
        <span>p99: <strong>0.7ms</strong></span>
        <span>brokers: <strong>Kite · Fyers · XTS</strong></span>
      </div>
    </div>
  );
};

/* ──────────────  AI AGENT TYPING DEMO  ────────────── */
const AI_SEQUENCE = [
  { who: 'user', text: '> classify support ticket #4821' },
  { who: 'agent', text: 'reading…  ' },
  { who: 'agent', text: 'category: billing · refund · subscription' },
  { who: 'agent', text: 'sentiment: frustrated (-0.72)' },
  { who: 'agent', text: 'recommended: route to T-2 with draft reply' },
  { who: 'user', text: '> draft reply' },
  { who: 'agent', text: 'Hi Maya — totally fair frustration. ' },
  { who: 'agent', text: "Your charge on Oct 14 was a renewal we'll refund today." },
  { who: 'agent', text: 'Sending confirmation now → bill-svc-71 ✓' },
];

const AIDemo = () => {
  const [lines, setLines] = useState([]);
  const [typing, setTyping] = useState('');
  const idxRef = useRef(0);
  const tRef = useRef(null);
  useEffect(() => {
    const next = () => {
      const seq = AI_SEQUENCE[idxRef.current % AI_SEQUENCE.length];
      let i = 0;
      const speed = seq.who === 'user' ? 28 : 22;
      tRef.current = setInterval(() => {
        i += 1;
        setTyping(seq.text.slice(0, i));
        if (i >= seq.text.length) {
          clearInterval(tRef.current);
          setLines((prev) => [...prev, seq].slice(-7));
          setTyping('');
          idxRef.current += 1;
          setTimeout(next, 800);
        }
      }, speed);
    };
    next();
    return () => clearInterval(tRef.current);
  }, []);

  return (
    <div className="demo-ai">
      <div className="ai-head">
        <span className="ai-orb" />
        <span>koda.agent · gpt-feral-2</span>
        <span className="ai-tokens">1.2k tok/s</span>
      </div>
      <div className="ai-body">
        {lines.map((l, i) => (
          <div key={`${l.text}-${i}`} className={`ai-line ai-${l.who}`}>{l.text}</div>
        ))}
        {typing && (
          <div className={`ai-line ai-${AI_SEQUENCE[idxRef.current % AI_SEQUENCE.length].who}`}>
            {typing}<span className="ai-caret">▍</span>
          </div>
        )}
      </div>
    </div>
  );
};

/* ──────────────  CODE / DIFF DEMO  ────────────── */
const highlight = (text) =>
  text
    .replace(/(export|async|function|const|return|await|on|=>)\b/g, '<span class="kw">$1</span>')
    .replace(/\b(true|false|null|undefined)\b/g, '<span class="lit">$1</span>')
    .replace(/("[^"]*")/g, '<span class="str">$1</span>')
    .replace(/\b(broker|router|ledger|metrics|enrich|placeOrder|observe|write|optimal|send|fill)\b/g, '<span class="id">$1</span>');

const CODE_LINES = [
  { t: ' ', text: 'export async function placeOrder(order) {' },
  { t: '-', text: '  const result = await broker.send(order);' },
  { t: '+', text: '  const result = await router.optimal(order);' },
  { t: ' ', text: '  return enrich(result, { latencyMs: now() - t0 });' },
  { t: ' ', text: '}' },
  { t: ' ', text: '' },
  { t: ' ', text: 'router.on("fill", (fill) => {' },
  { t: '+', text: '  metrics.observe("order_fill_ms", fill.latencyMs);' },
  { t: ' ', text: '  ledger.write(fill);' },
  { t: ' ', text: '});' },
];

const CodeDemo = () => (
  <div className="demo-code">
    <div className="code-head">
      <div className="code-tab is-on">trade.rs</div>
      <div className="code-tab">router.rs</div>
      <div className="code-tab">ledger.ts</div>
    </div>
    <pre className="code-body">
      {CODE_LINES.map((l, i) => (
        <div key={i} className={`cd-line cd-${l.t === '+' ? 'add' : l.t === '-' ? 'rem' : 'nil'}`}>
          <span className="cd-num">{String(i + 1).padStart(2, ' ')}</span>
          <span className="cd-sign">{l.t}</span>
          {/* eslint-disable-next-line react/no-danger */}
          <code dangerouslySetInnerHTML={{ __html: highlight(l.text) }} />
        </div>
      ))}
    </pre>
  </div>
);

/* ──────────────  DESIGN PLAYGROUND  ────────────── */
const PALETTES = [
  ['#d100a3', '#7c3aed', '#f472d0'],
  ['#10b981', '#0ea5e9', '#34d399'],
  ['#f59e0b', '#ef4444', '#fb923c'],
  ['#6366f1', '#8b5cf6', '#a78bfa'],
];

const DesignDemo = () => {
  const [p, setP] = useState(0);
  const [radius, setRadius] = useState(20);
  const pal = PALETTES[p];
  return (
    <div className="demo-design">
      <div
        className="dd-card"
        style={{
          background: `linear-gradient(135deg, ${pal[0]}, ${pal[1]})`,
          borderRadius: radius,
          boxShadow: `0 24px 60px ${pal[0]}55`,
        }}
      >
        <div className="dd-card-glyph" style={{ borderRadius: Math.max(6, radius / 2.4) }} />
        <div className="dd-card-meta">
          <div className="dd-card-h">Lume Pro</div>
          <div className="dd-card-p">From $9 / month</div>
        </div>
      </div>
      <div className="dd-controls">
        <div className="dd-ctrl">
          <div className="dd-ctrl-label">palette</div>
          <div className="dd-pals">
            {PALETTES.map((cols, i) => (
              <button
                key={cols.join()}
                type="button"
                className={`dd-pal ${i === p ? 'is-on' : ''}`}
                onClick={() => setP(i)}
                aria-label={`palette ${i + 1}`}
              >
                {cols.map((c) => <span key={c} style={{ background: c }} />)}
              </button>
            ))}
          </div>
        </div>
        <div className="dd-ctrl">
          <div className="dd-ctrl-label">radius · {radius}px</div>
          <input
            type="range" min="0" max="48" value={radius}
            onChange={(e) => setRadius(+e.target.value)}
            className="dd-slider"
            aria-label="corner radius"
          />
        </div>
      </div>
    </div>
  );
};

/* ──────────────  SECURITY PACKETS DEMO  ────────────── */
const SEC_EVENTS = [
  { sev: 'ok', src: '10.0.0.5', dst: '443/tcp', msg: 'SYN — handshake established' },
  { sev: 'warn', src: '45.33.32.156', dst: '22/tcp', msg: 'SSH burst — 5 attempts / 6s' },
  { sev: 'ok', src: '10.0.0.12', dst: 'api.feral', msg: 'GET /v1/trades · 200 OK · 84ms' },
  { sev: 'crit', src: '78.45.12.91', dst: '3389/tcp', msg: 'RDP scan blocked · fortress.fw' },
  { sev: 'ok', src: '10.0.0.7', dst: 'cdn.lume', msg: 'TLS 1.3 · cipher OK' },
  { sev: 'warn', src: '192.168.68.55', dst: '53/udp', msg: 'DNS spike — NAS investigating' },
  { sev: 'ok', src: '10.0.0.4', dst: 'agents.live', msg: 'WebSocket frame · 412 bytes' },
  { sev: 'crit', src: '203.0.113.66', dst: '80/tcp', msg: 'WAF rule R-029 fired · 403' },
];

const SecurityDemo = () => {
  const [feed, setFeed] = useState([0, 1, 2, 3, 4]);
  useEffect(() => {
    let i = 5;
    const t = setInterval(() => {
      setFeed((prev) => {
        const next = [...prev, i % SEC_EVENTS.length];
        i += 1;
        return next.slice(-6);
      });
    }, 1100);
    return () => clearInterval(t);
  }, []);
  return (
    <div className="demo-sec">
      <div className="sec-head">
        <span className="sec-orb" />
        fortress · live packets · iface eth0
      </div>
      <div className="sec-rows">
        {feed.map((idx, i) => {
          const e = SEC_EVENTS[idx];
          return (
            <div key={`${idx}-${i}`} className={`sec-row sev-${e.sev}`}>
              <span className="sr-dot" />
              <span className="sr-src">{e.src}</span>
              <span className="sr-arrow">→</span>
              <span className="sr-dst">{e.dst}</span>
              <span className="sr-msg">{e.msg}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

/* ──────────────  COMPOSER  ────────────── */
const SERVICES = [
  { id: 'ios', title: 'iOS Development', tag: '15 apps shipped', rate: 'From $3,000',
    blurb: 'Native SwiftUI, StoreKit 2, CloudKit sync. Fifteen production apps and counting.', Demo: IOSDemo },
  { id: 'trade', title: 'Trading Platforms', tag: 'Sub-millisecond', rate: 'From $15,000',
    blurb: 'Rust execution engines, multi-broker routing, real-time WebSocket pipelines.', Demo: TradingDemo },
  { id: 'ai', title: 'AI Systems', tag: '6 systems live', rate: 'From $8,000',
    blurb: 'Not chatbot wrappers — real agents, automated workflows, intelligent pipelines.', Demo: AIDemo },
  { id: 'web', title: 'Full-stack Web', tag: '4 platforms in prod', rate: 'From $5,000',
    blurb: 'React/Next.js, Rust & Python backends. Real-time, auth, payments — and the diff.', Demo: CodeDemo },
  { id: 'design', title: 'Brand & UI Design', tag: 'Systems for 15+ products', rate: 'From $2,000',
    blurb: 'Design that converts. Brand systems, motion, prototypes, and design-to-code.', Demo: DesignDemo },
  { id: 'sec', title: 'Security & Infra', tag: 'Real-time monitoring', rate: 'From $10,000',
    blurb: 'Packet inspection, vulnerability scanning, hardened infrastructure. We built Fortress.', Demo: SecurityDemo },
];

const Capabilities = () => (
  <section className="r-section caps" id="capabilities">
    <div className="r-wrap">
      <div className="r-tag r-reveal">Capabilities</div>
      <h2 className="r-head r-reveal">
        What we build, <span className="r-gtxt">visible from here.</span>
      </h2>
      <p className="r-sub r-reveal r-d1">
        Six capabilities. Each one is shipping in production for someone today.
        Hover any tile — it&apos;s not a screenshot. It&apos;s running.
      </p>
      <div className="caps-grid">
        {SERVICES.map((s, i) => (
          <article key={s.id} className={`cap r-reveal r-d${(i % 6) + 1}`}>
            <div className="cap-demo-wrap">
              <s.Demo />
            </div>
            <div className="cap-meta">
              <div className="cap-tagline">
                <span className="cap-tag">{s.tag}</span>
                <span className="cap-rate">{s.rate}</span>
              </div>
              <h3 className="cap-h">{s.title}</h3>
              <p className="cap-p">{s.blurb}</p>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default Capabilities;
